import AOS from 'aos';
import "./modules/nav";
import { initLabel } from "./modules/floatLabels";
import "./modules/btns";

AOS.init({
    once: true,
})

document.addEventListener('DOMContentLoaded', function(){
    const headerBlock = document.querySelector('header');
    setTimeout(function(){
        headerBlock.style.opacity = '1';
   }, 900);
   initLabel()
});

window.addEventListener('load', AOS.refresh);
